import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import config from 'config'
import { Carousel } from 'react-responsive-carousel';
import {
  ContainerDivs,
  Link,
} from '../../components'
import Styles from './HomeTestimonials.css'

@CSSModules(Styles, {allowMultiple:true})
export default class HomeTestimonials extends Component {
  render() {
    const carouselItems = [
      [
        'fossil',
        config.routes.issueFossilFuels,
        'Fossil fuels',
        'Coal, oil, and gas release carbon pollution that accelerates the climate emergency. Rising temperatures will contribute to fires, floods, deadly heatwaves, and other environmental disasters.'
      ],
      [
        'prisons',
        config.routes.issuePrisonIndustrialComplex,
        'Prison industrial complex',
        'Investor-owned companies are profiting from exploitative prison labor, immigration jails, and other economic systems of oppression and exploitation.'
      ],
      [
        'deforestation',
        config.routes.issueDeforestation,
        'Deforestation',
        'Clearing rain forests for cattle grazing or palm oil production contributes to the climate crisis and threatens the rights of Indigenous peoples, traditional landowners, and local communities.'
      ],
      [
        'military',
        config.routes.issueArmsManufacturers,
        'Arms manufacturers',
        'Through the global weapons trade, some arms manufacturers supply military goods to states at risk of using weapons for oppression or aggression.'
      ],
      [
        'gender',
        config.routes.issueGenderEquality,
        'Gender equality',
        'Collecting data and scoring companies on gender equality is the first step towards sustainable change.'
      ],
      [
        'guns',
        config.routes.issueCivilianFirearms,
        'Civilian firearms',
        'Over 90% of the country supports expanding background checks to all gun sales and the majority supports increased safety regulation, but many of these same people are invested their savings in firearm manufacturers and don’t even know it.'
      ],
      [
        'tobacco',
        config.routes.issueTobacco,
        'Tobacco',
        'The World Health Organization describes tobacco as the most devastating, but preventable, epidemic of our time. Every day, more than 2,000 young Americans become daily smokers.'
      ],
    ]
    //
    return (
      <Carousel
        showStatus={false}
        showArrows={false}
        infiniteLoop={true}
        autoPlay={true}
        stopOnHover={true}
        swipeable={true}
        showThumbs={false}
        dynamicHeight={false}
        emulateTouch={true}
        interval={7000}
      >
        {
          carouselItems.map((e, i) => {
            const [style, url, title, description] = e
            return (
              <div
                styleName={'ht-img-bckgrnd-'+style}
                key={'carousel-item-'+i}
              >
                <ContainerDivs>
                  <h2 styleName='ht-hl'>
                    {title}
                  </h2>
                  <h3 styleName='ht-ds'>
                    {description}
                  </h3>
                  <div styleName='ht-tl'>
                    <Link
                      to={url}
                      title={'The issue: '+title}
                    >
                      Learn more{/* <LinkIcon /> */}
                    </Link>
                  </div>
                </ContainerDivs>
              </div>
            )
          })
        }
      </Carousel>


    )
  }
}

